import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-661bc518")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Inloggen", -1)
const _hoisted_2 = {
  key: 0,
  class: "alert"
}
const _hoisted_3 = { style: {"margin-bottom":"24px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  style: {"display":"block"},
  for: "email"
}, "E-mailadres", -1)
const _hoisted_5 = { style: {"margin-bottom":"24px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  style: {"display":"block"},
  for: "password"
}, "Wachtwoord", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button is-green",
    type: "submit"
  }, "Inloggen")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFormSubmit && _ctx.onFormSubmit(...args)), ["prevent"])),
    class: "form",
    novalidate: ""
  }, [
    _hoisted_1,
    (_ctx.incorrectCreds)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Je inloggegevens zijn incorrect."))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "control",
        type: "email",
        name: "email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.fields.email = $event))
      }, null, 512), [
        [_vModelText, _ctx.fields.email]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        class: "control",
        type: "password",
        name: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fields.password = $event))
      }, null, 512), [
        [_vModelText, _ctx.fields.password]
      ])
    ]),
    _hoisted_7
  ], 32))
}